<app-navbar-style-two></app-navbar-style-two>
<div class="container">
    <mat-tab-group>
      <mat-tab label="View Templates">
        <div align="center" *ngIf="gifLoader">
          <img height="100px" width="100px"
              src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="medeil gif"
              loading="lazy">
         </div>
        <div class="container mt-4">
          <div class="row" *ngFor="let page of landingPageData">
            <div class="col-md-12">
              <div
                class="custom-card"
                [ngStyle]="{'background': 'linear-gradient(90deg, ' + page.main_color + ' 0%, ' + page.sub_color + ' 100%)'}">
                <div class="card-body">
                  <h5 class="card-title">{{ page.template_name }}</h5>
                  <h2 class="card-header">{{ page.banner_header }}</h2>
                  <p class="card-text">{{ page.banner_sub_content }}</p>
                  <a (click)="viewPage(page)" class="btn-custom">
                    <i class="fa fa-eye"></i> View Page
                  </a>
                  <a class="btn-custom" (click)="editPage(page)">
                    <i class="fa fa-edit"></i> Edit Page
                  </a>
                  <a class="btn-custom" (click)="deleteData(page)">
                    <i class="fa fa-trash"></i> Delete Page
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </mat-tab>
      <mat-tab label="Add Templates">
        <div class="template-selection">
          <div class="form-container">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Select a Template</mat-label>
              <mat-select (selectionChange)="changeTemplate($event)">
                <mat-option *ngFor="let template of templates" [value]="template">
                  {{ template }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="button-container">
            <button class="btn gradient-btn" (click)="AddTempate('Template_1')"><i class="fa fa-plus icon"></i> Add Template</button>
          </div>
        </div>

        <app-template-one *ngIf="Template_1"></app-template-one>
      </mat-tab>


    </mat-tab-group>
  </div>


<app-footer-style-two></app-footer-style-two>



    <!-- <mat-tab label="Add Templates">
            <div class="container mt-4 mb-4">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="card template-card" [class.selected]="selectedCard === 'card1'" (click)="selectCard('card1')">
                            <img src="assets/img/lp1.PNG" class="card-img-top" alt="Template One">
                            <div class="card-overlay">
                                <button class="btn select-btn" (click)="AddTempate(1)">Add Template</button>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="card template-card" [class.selected]="selectedCard === 'card2'" (click)="selectCard('card2')">
                            <img src="assets/img/lp1.PNG" class="card-img-top" alt="Template Two">
                            <div class="card-overlay">
                                <h5 class="card-title">Select Template</h5>
                                <button class="btn select-btn">Add</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="card template-card" [class.selected]="selectedCard === 'card3'" (click)="selectCard('card3')">
                            <img src="assets/img/lp1.PNG" class="card-img-top" alt="Template Three">
                            <div class="card-overlay">
                                <h5 class="card-title">Select Template</h5>
                                <button class="btn select-btn">Add</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab> -->